var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-btn',{staticClass:"font-weight-bold",attrs:{"variant":"danger","disabled":_vm.loading,"block":""},on:{"click":_vm.OpenBox}},[_vm._v(" Close Tab ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }